import { createApp } from "vue";
import crosssection from './components/crosssection.vue';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import DialogService from 'primevue/dialogservice';
import PrimeVueDcf from './includes/primeVueDcf.js';
import fetchData from './includes/fetchData.js';
import errorHandler from './includes/errorHandler.js';

const app = createApp(crosssection);

app.mixin(fetchData);
app.mixin(errorHandler);

app.use(PrimeVue, PrimeVueDcf);
app.use(ToastService);
app.use(DialogService);


app.mount('#crosssection');

/*
import Vue from 'vue';

new Vue({
  el: '',
  components: { 'crosssection': crosssection },
  data: { },
  template: '<crosssection></crosssection>'
});
/**/
